// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-query .el-form-item {\n  margin-bottom: 0;\n}\n.search-query .select-label .el-input__inner,\n.search-query .select-label .el-input__icon {\n  line-height: 28px;\n  height: 28px;\n}\n.search-query .select-label .el-input__inner {\n  border: 0;\n  padding: 0;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
